import React from 'react';

import burgerLogo from '../../../assets/images/burger-logo.png';
import './style.css';

const logo = props => (
  <div className="Logo">
    <img src={burgerLogo} alt="MyBurger" />
  </div>
);

export default logo;
